import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ConfirmationService } from 'primeng/primeng';
import { MessageService } from 'primeng/components/common/messageservice';
import { WebPage } from '../../shared/web-page';
import { AuthService } from '../../admin/auth.service';
import { CandidatoService } from '../../candidato/candidato.service';
import { LaboratorioService } from '../../laboratorio/laboratorio.service';
import { EditalCredenciamentoService } from '../../editalCredenciamento/edital-credenciamento.service';
import { Util } from '../../shared/util';
import { ClinicaService } from '../../clinica/clinica.service';

@Component({
  templateUrl: './solicitar-exame-medico-psicologico.component.html',
})
export class SolicitarExameMedicoPsicologicoComponent extends WebPage implements OnInit {

  edital = null;
  idCandidato;
  candidato;
  mostraDivPesquisaCnpj = false;
  clinica;

  constructor(
    private route: ActivatedRoute, private router: Router,
    private confirmationService: ConfirmationService, messageService: MessageService,
    private authService: AuthService,
    private candidatoService: CandidatoService, private editalCredenciamentoService: EditalCredenciamentoService,
    private clinicaService: ClinicaService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params =>
      this.idCandidato = params.get('idCandidato')
    );
  }

  ngOnInit() {
    this.isLoading = true;
    this.candidatoService.getFull(this.idCandidato)
    .finally(() => this.isLoading = false)
    .subscribe(
      candidato => {
        this.candidato = candidato;

        this.isLoading = true;
        // this.editalCredenciamentoService.getEditalClinicaVigenteByIdUnidade(candidato.idUnidade)
        //   .subscribe(
        //     edital => {
        //       this.edital = edital;
        //       this.mostraDivPesquisaCnpj = !edital.isDistribuicaoEquitativa;
        //     },
        //     error => this.gerenciaErro(error)
        //   );
      },
      error => this.gerenciaErro(error)
    );
  }

  consultaCnpj(cnpj: string) {
    const cnpjLimpo = Util.limpaCnpj(cnpj);

    if (!Util.isCnpj(cnpjLimpo)) {
      this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Cnpj inválido!' });
      return;
    }

    this.isLoading = true;
    this.clinicaService.getByCnpj(cnpjLimpo)
      .finally(() => this.isLoading = false)
      .subscribe(
        clinica => this.clinica = clinica,
        error => this.gerenciaErro(error)
      );
  }

  gerarGuia() {
    // if (Util.isNullOrEmptyOrUndefined(this.edital)) {
    //   this.messageService.add({
    //     severity: 'warn',
    //     summary: 'Atenção',
    //     detail: 'Não foi encontrado nenhum edital de clínica vigente para a unidade informada!'
    //   });
    //   return;
    // }

    // if (this.mostraDivPesquisaCnpj && Util.isNullOrEmptyOrUndefined(this.clinica)) {
    //   this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Prestador de serviço não selecionado!' });
    //   return;
    // }

    this.confirmationService.confirm({
      message: 'Tem certeza que deseja emitir a guia de encaminhamento para este aluno?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        const usuario = this.authService.informacoesUsuario();
        const idClinica = (!Util.isNullOrEmptyOrUndefined(this.clinica)) ? this.clinica.idClinica : null;
        this.isLoading = true;
        this.candidatoService.encaminharExameMedicoPsicologico(this.idCandidato, idClinica, usuario.Nome);

        window.setTimeout(
          () => this.router.navigate(['/gerenciar-exame-medico-psicologico/' + this.idCandidato]),
          2000
        );
      },
      reject: () => {
        this.messageService.add({ severity: 'warn', summary: 'Atenção', detail: 'Dados não enviados!' });
      }
    });
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/gerenciar-exame-medico-psicologico/' + this.idCandidato]);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/exameMedicoPsicologico/solicitar-exame-medico-psicologico/solicitar-exame-medico-psicologico.component.ts